module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/kg-4ad89b3a703d225e1f6d2e2128d573ea.svg";